import {decompress, Compressed} from 'compress-json'

class JsonCompressionService {
  private static instance: JsonCompressionService

  static getInstance(): JsonCompressionService {
    if (!JsonCompressionService.instance) {
      JsonCompressionService.instance = new JsonCompressionService()
    }
    return JsonCompressionService.instance
  }

  private restoreDates(obj: object | unknown): object | unknown {
    if (!obj || typeof obj !== 'object') {
      return obj
    }
    
    if ('__type' in obj && obj.__type === 'Date' && '__value' in obj && typeof obj.__value === 'string') {
      return new Date(obj.__value)
    }
    
    if (Array.isArray(obj)) {
      return obj.map(item => this.restoreDates(item))
    }
    
    if (typeof obj === 'object') {
      const restored: Record<string, unknown> = {}
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          restored[key] = this.restoreDates((obj as Record<string, unknown>)[key])
        }
      }
      return restored
    }
    
    return obj
  }

  decompress<T = unknown>(compressedData: Compressed): T {
    try {
      const decompressed = decompress<T>(compressedData)
      return this.restoreDates(decompressed) as T
    } catch (error) {
      throw new Error(`Failed to decompress data: ${error instanceof Error ? error.message : 'Unknown error'}`, {
        cause: error,
      })
    }
  }
}

export const jsonCompressionService = JsonCompressionService.getInstance()

